[
  {
    "audioSha256": "8834fc8627acf38ef2a3c77ae60c584624f2d0636e243785333a866746c84521",
    "durationMs": 18573,
    "spokenText": "哎呀！What the fuck are you doing? Twenty-times leverage on a shitcoin?! You call that investing? My bloody wok has better risk management! 够了！Stop chasing every fucking candle! 听我说，心要稳。Your money can shake. Your heart can stay steady. 加油！We get rekt, we learn, we bloody rebuild!",
    "swearTimings": [
      {
        "word": "fuck",
        "startMs": 1162,
        "endMs": 1362,
        "confidence": 0.663
      },
      {
        "word": "shitcoin?!",
        "startMs": 3566,
        "endMs": 4087,
        "confidence": 0.864
      },
      {
        "word": "bloody",
        "startMs": 5911,
        "endMs": 6191,
        "confidence": 0.881
      },
      {
        "word": "fucking",
        "startMs": 9878,
        "endMs": 10218,
        "confidence": 0.772
      },
      {
        "word": "bloody",
        "startMs": 17752,
        "endMs": 18092,
        "confidence": 0.866
      }
    ]
  },
  {
    "audioSha256": "df0c2d7c570792653f4f1d5d36d475008a7789cc1c31cc2d35b8ebe9c3214b47",
    "durationMs": 3383,
    "spokenText": "Why you dirty motherfucking cocksuckin' piece of shit!",
    "swearTimings": [
      {
        "word": "motherfucking",
        "startMs": 1621,
        "endMs": 2228,
        "confidence": 0.481
      },
      {
        "word": "cocksuckin'",
        "startMs": 2269,
        "endMs": 2816,
        "confidence": 0.59
      },
      {
        "word": "shit!",
        "startMs": 3180,
        "endMs": 3383,
        "confidence": 0.517
      }
    ]
  }
]
